import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "How is my personal data collected during registration?",
  answer: "We collect data directly through our secure ticketing platform when you purchase passes or register for workshops. This includes basic contact information, professional affiliation, and any specific accessibility or dietary requirements needed to ensure a seamless event experience."
}, {
  id: "faq-2",
  question: "Where is my information stored and how is it secured?",
  answer: "Your data is housed in encrypted, SOC 2 Type II compliant cloud servers. We utilize industry-standard AES-256 encryption for data at rest and TLS 1.2+ for all data in transit, ensuring your personal details remain protected against unauthorized access."
}, {
  id: "faq-3",
  question: "Under what circumstances is data shared with partners?",
  answer: "Data is only shared with official event partners if you explicitly opt-in during registration or allow your badge to be scanned at specific exhibitor booths. We never sell your personal information to third-party brokers or unrelated marketing entities."
}, {
  id: "faq-4",
  question: "Is the event compliant with GDPR and international privacy laws?",
  answer: "Yes. We strictly adhere to GDPR, CCPA, and other global privacy frameworks. Attendees have the right to access their data, request corrections, or ask for total deletion from our systems at any time by contacting our dedicated privacy officer."
}, {
  id: "faq-5",
  question: "How long do you retain attendee data after the event?",
  answer: "We retain basic registration records for up to 24 months to facilitate alumni discounts and historical reporting. After this period, personal identifiers are either anonymized for statistical analysis or permanently purged from our active databases."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="257667" id="data-practices" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8 max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary mb-6 tracking-tight">
            Data Practices & Privacy
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-2xl mx-auto leading-relaxed">
            Learn how we protect your information and maintain global compliance standards for our international gatherings.
          </p>
        </div>
        
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-none bg-card rounded-md px-6 shadow-md transition-all duration-200 hover:shadow-lg">
              <AccordionTrigger className="text-left font-default text-lg font-semibold text-foreground hover:no-underline data-[state=open]:text-primary py-6 [&[data-state=open]>svg]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground font-default pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}